import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export type AlertType = 'success' | 'error' | 'warning' | 'info';

export interface AlertDialogData {
  type: AlertType;
  title: string;
  message: string;
  enableCancelBtn: boolean;
}

const ALERT_ICONS: Record<AlertType, string> = {
  success: 'check_circle',
  error: 'error',
  warning: 'warning',
  info: 'info',
};

@Component({
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrl: './alert-dialog.component.scss',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<AlertDialogComponent, boolean>);
  readonly data = inject<AlertDialogData>(MAT_DIALOG_DATA);

  readonly icon = ALERT_ICONS[this.data.type];

  // Sizing (width/max-width) is enforced via ::ng-deep on .mat-mdc-dialog-panel in
  // alert-dialog.component.scss, not here.
  static open(dialog: MatDialog, data: AlertDialogData): MatDialogRef<AlertDialogComponent, boolean> {
    return dialog.open(AlertDialogComponent, {
      disableClose: !data.enableCancelBtn,
      data,
    });
  }

  confirm(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
